module.exports = __webpack_public_path__ + "src/assets/img/phone.6a29b2fc.png";